import { IHasServices } from './IHasServices';

export class Department implements IHasServices {
    public name: string;
    public departmentId: string;
    public hasTicketApp: boolean;

    constructor(name: string, departmentId: string) {
        this.name = name;
        this.departmentId = departmentId;
    }
}
